export default {
    mounted(selfEl, binding) {
        const targetEl = document.querySelector(binding.value);
        const targetRect = targetEl?.getBoundingClientRect();
        /**
         * 마우스 이동
         */
        const mouseMove = (e) => {
            if (!targetEl) {
                return;
            }
            const value = e.clientX - targetRect.x - 10;
            targetEl.style.width = `${value}px`;
            // body에 스타일을 주어야 마우스가 이동시 커서가 범위를 넘어도 정상적으로 보여짐
            // eslint-disable-next-line no-param-reassign
            document.body.style.cursor = 'ew-resize';
        };
        /**
         * 이벤트 종료
         */
        const eventEnd = () => {
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('mouseup', eventEnd);
            document.body.style.cursor = '';
            localStorage.setItem('invoice-delivery-charge-width', targetEl.style.width);
        };
        /**
         * 이벤트 시작
         */
        const eventStart = () => {
            if (!targetEl) {
                return;
            }
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('mouseup', eventEnd);
        };
        /**
         * 이벤트 제거
         */
        const destroy = () => {
            selfEl.removeEventListener('mousedown', eventStart);
        };
        /**
         * 초기화
         */
        const init = () => {
            const resizerX = localStorage.getItem('invoice-delivery-charge-width');
            if (resizerX) {
                targetEl.style.width = resizerX;
            }
            selfEl.addEventListener('mousedown', eventStart);
            // eslint-disable-next-line no-param-reassign
            selfEl.__vResizeCleanup__ = destroy;
            // eslint-disable-next-line no-param-reassign
            selfEl.style.cursor = 'col-resize';
        };
        init();
    },
    unmounted(selfEl) {
        const destroy = selfEl.__vResizeCleanup__;
        if (typeof destroy === 'function') {
            destroy();
        }
    },
};
